import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router';
import Logo from '../../../assets/Login_logo.png';
import Policy from '../../../components/table/policy';

import TermsConditionBottom from '../../../components/table/termsConditionBtm';

const useStyles = makeStyles((theme) => ({
    imcCard: {
        background: '#63637d',
        minHeight: '150px',
        borderRadius: '6px',
        color: '#ffffff',
        fontFamily: 'Rubik',
        padding: '30px',
    },
    imcCardTitle: {
        fontSize: '16px',
    },
    imcCardImg: {
        width: '50%',
        '& img': {
            margin: '30px 0 10px',
            height: '60px',
        },
    },
    imcCardMore: {
        fontSize: '12px',
        fontWeight: '100',
        cursor: 'pointer',
    },
}));

export default function PrivacyFooter() {
    const classes = useStyles();
    const history = useHistory();
    const [showDialogBox, setShowDialogBox] = React.useState(false);
    const [showDialogBoxTerms, setshowDialogBoxTerms] = React.useState(false);
    const navigate = () => {
        // history.push('/menu/ClientIndividualCreate');
        history.push('/menu/CreateCpsChecklist');
    };
    const openInNewTabMain = () => {
        window.open('https://www.advithitec.in/', '_blank');
    };
    const openInNewTab = () => {
        window.open('https://www.advithitec.in/#contact', '_blank');
    };
    const handlePolicy = () => {
        setShowDialogBox(true);
    };
    const handlePolicyClose = () => {
        setShowDialogBox(false);
    };
    const handleTerms = () => {
        setshowDialogBoxTerms(true);
    };
    const handleTermsClose = () => {
        setshowDialogBoxTerms(false);
    };

    return (
        <>
            <div className="btmMenu">
                <div className="btmLogo">
                    <img src={Logo} alt="logo" className={classes.logo} onClick={openInNewTabMain} />
                </div>
                <div className="btmLogin">
                    <ul className="displayInline">
                        <li>&#169; Copyright 2021 Advith ITeC</li>
                        <li onClick={handlePolicy}>Privacy Policy</li>
                        <li onClick={openInNewTab}>Contact Us</li>
                        <li onClick={handleTerms}>Terms and Condition</li>
                    </ul>
                </div>
            </div>

            {showDialogBox && (
                <Policy
                    showDialogBox={showDialogBox}
                    // updateCRCRelevance={updateCRCRelevance}
                    handlePolicyClose={handlePolicyClose}
                    // relevanceindex={relevanceindex}
                    // crcCategory={category}
                    // crcRemarks={remarks}
                />
            )}
            {showDialogBoxTerms && (
                <TermsConditionBottom
                    showDialogBoxTerms={showDialogBoxTerms}
                    // updateCRCRelevance={updateCRCRelevance}
                    handleTermsClose={handleTermsClose}
                    // relevanceindex={relevanceindex}
                    // crcCategory={category}
                    // crcRemarks={remarks}
                />
            )}
        </>
    );
}
